import React, { Component } from 'react'
import { routerActions } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Header, Button, Segment, Form, Modal, Message } from 'semantic-ui-react'
import numeral from 'numeral'
import moment from 'moment'
import * as Reservation from '../../store/Reservations'
class EditReservation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reservation: null,
            additionalInfo: null,
            showCancel: false,
            showConfirmCharges: false,
            chargeConfirmText: '',
            updateError: null,
        }
        this.onChange = this.onChange.bind(this)
        this.onAdditionalInfoChange = this.onAdditionalInfoChange.bind(this)
        this.onSave = this.onSave.bind(this)
        this.onCancel = this.onCancel.bind(this)
        this.onConfirmCharges = this.onConfirmCharges.bind(this)
        this.onShowCancel = this.onShowCancel.bind(this)
        this.onHideCancel = this.onHideCancel.bind(this)
        this.onPaid = this.onPaid.bind(this)
        this.onMailed = this.onMailed.bind(this)
    }
    async componentDidMount() {
        const { actions, confirmation } = this.props
        const reservation = await actions.getReservation(confirmation)
        console.log(reservation)
        this.setState({ reservation: reservation.response, additionalInfo: JSON.parse(reservation.response.additionalInformation) })
    }
    onChange(e, { name, value }) {
        const { reservation } = this.state
        this.setState({ reservation: { ...reservation, [name]: value } })
    }
    onAdditionalInfoChange(e, { name, value }) {
        const { additionalInfo } = this.state
        this.setState({ additionalInfo: { ...additionalInfo, [name]: value } })
    }
    async onCancel(e) {
        const { reservation, additionalInfo } = this.state
        const { actions } = this.props
        const updated = await actions.updateReservation({ ...reservation, status: 3, additionalInformation: JSON.stringify(additionalInfo) })
        this.setState({ showCancel: false, reservation: updated.response, additionalInfo: JSON.parse(updated.response.additionalInformation) })
        actions.getReservations(reservation.id)
    }
    onShowCancel(e) {
        this.setState({ showCancel: true })
    }
    onHideCancel(e) {
        this.setState({ showCancel: false, showConfirmCharges: false, chargeConfirmText: '' })
    }
    async onPaid(e) {
        const { reservation, additionalInfo } = this.state
        const { actions } = this.props
        const updated = await actions.updateReservation({ ...reservation, status: 1, isPaid: true, additionalInformation: JSON.stringify(additionalInfo) })
        this.setState({ reservation: updated.response, additionalInfo: JSON.parse(updated.response.additionalInformation) })
        actions.getReservations(reservation.id)
    }
    async onMailed(e) {
        const { reservation, additionalInfo } = this.state
        const { actions } = this.props
        const updated = await actions.updateReservation({ ...reservation, isMailed: true, isPaid: true, additionalInformation: JSON.stringify(additionalInfo) })
        this.setState({ reservation: updated.response, additionalInfo: JSON.parse(updated.response.additionalInformation) })
        actions.getReservations(reservation.id)
    }
    onConfirmCharges(e) {
        const { reservation } = this.state
        const { blocks, spots, charges } = reservation
        const total = blocks.reduce((acc, block) => acc + spots * block.inventoryBlock.rate, 0)
        const alreadyCharged = charges.reduce((acc, charge) => acc + charge.balance, 0)
        if (total - alreadyCharged > 0) {
            this.setState({
                showConfirmCharges: true,
                chargeConfirmText: `The changes requested results in an additional Charge of ${numeral(total - alreadyCharged).format('$ 0,0.00')}`,
            })
        } else if (total - alreadyCharged < 0) {
            this.setState({
                showConfirmCharges: true,
                chargeConfirmText: `The changes requested results in a refund of ${numeral((total - alreadyCharged) * -1).format('$ 0,0.00')}`,
            })
        } else {
            this.onSave(e)
        }
    }
    async onSave(e) {
        const { reservation, additionalInfo } = this.state
        const { actions } = this.props
        try {
            const updated = await actions.updateReservation({ ...reservation, additionalInformation: JSON.stringify(additionalInfo) })
            this.setState({ reservation: updated.response, additionalInfo: JSON.parse(updated.response.additionalInformation), showConfirmCharges: false, chargeConfirmText: '' })
            actions.getReservations(reservation.id)
        } catch (error) {
            this.setState({ updateError: error.message })
        }
    }
    render() {
        const { reservation, additionalInfo, showCancel, showConfirmCharges, chargeConfirmText, updateError } = this.state
        if (!reservation) return <div />
        const { inventory, spots, blocks, status, charges } = reservation
        console.log(reservation, blocks)
        const { event, facility } = inventory
        const parker = reservation
        const statusText = () => {
            switch (status) {
                case 0:
                    return 'Pending'
                case 1:
                    return 'Reserved'
                case 2:
                    return 'Expired'
                case 3:
                    return 'Cancelled'
                default:
                    break
            }
        }
        const additionalFields = event && event.additionalFields ? JSON.parse(event.additionalFields) : {}
        console.log(status)
        return (
            <Container>
                <Modal open={showCancel}>
                    <Modal.Header content="Cancel Reservation?" />
                    <Modal.Content>
                        <Header as="h3" content="Are you sure you want to cancel the reservation and refund the following charges?" />
                        {charges
                            .filter((c) => c.balance > 0)
                            .map((c) => (
                                <div>{`${moment(c.transactionDate).format('L')} - ${numeral(c.balance).format('$ 0,0.00')}`}</div>
                            ))}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative content="Refund and Cancel Reservation" onClick={this.onCancel} />
                        <Button content="Close" onClick={this.onHideCancel} />
                    </Modal.Actions>
                </Modal>
                <Modal open={showConfirmCharges} error>
                    <Modal.Header content="Confirm Changes" />
                    <Modal.Content>
                        {updateError ? <Message error content={updateError} /> : null}
                        <Header as="h3" content="Are you sure you want to update the reservation?" />
                        {chargeConfirmText}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button content="Close" onClick={this.onHideCancel} />
                        <Button primary content="Continue" onClick={this.onSave} />
                    </Modal.Actions>
                </Modal>
                <Segment>
                    <Header as="h1" content={`Event: ${event.name}`} />
                    <Header as="h2" content={`Status: ${statusText()}`} />
                    {status === 0 ? <Button positive content="Mark Paid" onClick={this.onPaid} /> : null}
                    {status === 1 && !reservation.isMailed ? <Button positive content="Mark Mailed" onClick={this.onMailed} /> : null}
                    {status < 3 ? <Button negative content="Cancel Reservation" onClick={this.onShowCancel} /> : null}
                    <Form>
                        <Form.Group>
                            <Form.Input disabled={true} width={3} label="Spots" placeholder="Spots" name="spots" value={spots} />
                        </Form.Group>
                    </Form>
                    <div className="selected parking">
                        {blocks.map((block) => (
                            <div>
                                <div>{`${block.inventoryBlock.name} - ${spots} ${spots > 1 ? 'spots' : 'spot'} @ ${numeral(block.inventoryBlock.rate).format(
                                    '$0,0.00'
                                )} each`}</div>
                            </div>
                        ))}
                    </div>
                    <div>
                        <strong>Total charged:</strong> {`${numeral(blocks.reduce((acc, block) => acc + spots * block.inventoryBlock.rate, 0)).format('$0,0.00')}`}
                    </div>
                    <Header as="h4" content="Facility Details" />
                    <div className="selected facility">
                        <div>
                            {facility.name} {facility.address}
                        </div>
                        <div>Type: {facility.isLot ? 'Lot' : `Garage - ${facility.clearanceFeet}'${facility.clearanceInches}''`}</div>
                        <Header as="h5" content="Directions:" />
                        <div dangerouslySetInnerHTML={{ __html: facility.directions }} />
                    </div>
                </Segment>
                <Segment>
                    <Header as="h4" content="Parker Information" />
                    <Form>
                        <Form.Group>
                            <Form.Input disabled={status === 3} width={8} label="Name" placeholder="Name" name="name" value={parker.name} onChange={this.onChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input disabled={status === 3} width={8} label="Address" placeholder="Address" name="address" value={parker.address} onChange={this.onChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input
                                disabled={status === 3}
                                width={8}
                                label="Address 2"
                                placeholder="Address 2"
                                name="address2"
                                value={parker.address2}
                                onChange={this.onChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input disabled={status === 3} width={4} label="City" placeholder="City" name="city" value={parker.city} onChange={this.onChange} />
                            <Form.Input disabled={status === 3} width={2} label="State" placeholder="State" name="state" value={parker.state} onChange={this.onChange} />
                            <Form.Input disabled={status === 3} width={2} label="Zip" placeholder="Zip" name="zip" value={parker.zip} onChange={this.onChange} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input
                                disabled={status === 3}
                                width={4}
                                label="Mobile Phone"
                                placeholder="Mobile Phone"
                                name="mobile"
                                value={parker.mobile}
                                onChange={this.onChange}
                            />
                            <Form.Field>
                                <p className="mobile legal">By providing a mobile number, you authorize Denison Parking to send confirmation via SMS. Regular rates apply.</p>
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Input disabled={status === 3} width={8} label="Email" placeholder="Email" name="email" value={parker.email} onChange={this.onChange} />
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment>
                    <Header as="h4" content="Event Information" />
                    <Form>
                        {Object.keys(additionalFields).map((f) => (
                            <Form.Group>
                                <Form.Input
                                    disabled={status === 3}
                                    width={8}
                                    label={additionalFields[f].label}
                                    placeholder={additionalFields[f].label}
                                    name={additionalFields[f].name}
                                    value={additionalInfo[additionalFields[f].name]}
                                    onChange={this.onAdditionalInfoChange}
                                />
                            </Form.Group>
                        ))}
                    </Form>
                </Segment>
                <Button disabled={status === 3} style={{ margin: 'auto', display: 'block' }} primary content="Save Reservation" onClick={this.onConfirmCharges} />
            </Container>
        )
    }
}

EditReservation.propTypes = {}

const mapStateToProps = (state, ownProps) => {
    return {
        confirmation: ownProps.match.params.confirmation,
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Reservation.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(EditReservation)
)
